import * as cds from "./CESSDK";
import * as cdsAccount from "./CESAccount";

interface MyWindow extends Window {
    cds: any;
    Account: any;
    onCaptchaSubmit: any;
}

declare let window: MyWindow;

window.cds = cds;
window.Account = cdsAccount;
